import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { updateTemplateField } from "../../../../redux/reducers/TemplateField";
import {
  TemplateFieldV2,
  Rectangle,
} from "../../../../docuclipper/DocuclipperTypes";
import { RectanglePages } from "../RectanglePages";
import { withSelectedField } from "./withSelectedField";
type Props = {
  field: TemplateFieldV2;
};

const PageSelector2: React.SFC<Props> = ({ field }) => {
  const dispatch = useDispatch();

  const { page } = useSelector((state: ReduxState) => state.TemplateField);

  let pageNumber = -1;
  if (page.page) {
    pageNumber = page.page.pageNumber;
  }
  const rectangle: Rectangle = {
    vlocationEnabled: field.locationType === "variable",
    includePages: field.pages.include || [],
    excludePages: field.pages.exclude || [],
    applyToAllPages: field.pages.pagesType === "allPages",
    pageNumber,
    id: field.id,
  } as any;

  const updateRectangle = (
    {
      id,
      applyToAllPages,
      includePages,
      excludePages,
    }: {
      id: string;
      applyToAllPages: boolean;
      includePages: string[];
      excludePages: string[];
    },
    pageNumber: number
  ) => {
    let pagesType: TemplateFieldV2["pages"]["pagesType"] = "currentPage";
    if (includePages.length > 0 || excludePages.length > 0) {
      pagesType = "custom";
    } else if (applyToAllPages) {
      pagesType = "allPages";
    }
    dispatch(
      updateTemplateField({
        id: field.id,
        update: {
          pages: {
            exclude: excludePages,
            include: includePages,
            page: pageNumber,
            pagesType,
          },
        },
      })
    );
  };
  return (
    <>
      {/* <div className="h5">Pages</div> */}
      <RectanglePages
        selectedRectangle={rectangle}
        pageNumber={pageNumber}
        updateRectangle={updateRectangle as any}
      />
    </>
  );
};

export const PageSelector = withSelectedField(PageSelector2);
